import React from 'react'

export default function UiTopInputElementsWr(props) {
    
    return (
        <>
            <div className='sb-top-area-element'>
                {props.children}
            </div>
        </>
    )
}
